import { render, staticRenderFns } from "./VideoDetailsCard.vue?vue&type=template&id=08a66e09&"
import script from "./VideoDetailsCard.vue?vue&type=script&lang=js&"
export * from "./VideoDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./VideoDetailsCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports